class DocWebScanService {
    ping = () => this.callApi('Ping');
    getList = () => this.callApi('GetTwainSources', '', 'POST');
    getDocument = (data, port) => this.callApi('TWAINAcquire2', data, 'POST', port);

    callApi(endpoint, data = '', method = 'GET', port = '56857') {
        const url = `https://localhost:${port}/DocWebScan/${endpoint}`;

        var requestOptions = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
            },
            body: data ? JSON.stringify(data) : null,
        };

        return fetch(url, requestOptions).then((response) => response.json());
    }
}

export default new DocWebScanService();
